import { CPUCapability, DEFAULT_DEVICE } from './models';
var cachedDevice;

var isTizen = function isTizen(userAgent) {
  return !!userAgent.match(/^(?=.*Tizen).*$/im);
};

export var toSamsungDevice = function toSamsungDevice(friendlyName, osVersion) {
  return {
    capabilities: {
      cpu: CPUCapability.High,
      cssVariables: false
    },
    platform: 'samsung',
    friendlyName: friendlyName,
    osVersion: osVersion
  };
};
export var getSamsungDevice = function getSamsungDevice() {
  var _window, _webapis, _webapis$productinfo, _webapis2;

  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  if (!isTizen(userAgent) || !((_window = window) !== null && _window !== void 0 && _window.webapis)) {
    return DEFAULT_DEVICE;
  } // webapis.productinfo has a slight overhead so let's cache the result to be safe


  if (cachedDevice) {
    return cachedDevice;
  }

  var model = (_webapis = webapis) === null || _webapis === void 0 ? void 0 : (_webapis$productinfo = _webapis.productinfo) === null || _webapis$productinfo === void 0 ? void 0 : _webapis$productinfo.getModel();
  var version = (_webapis2 = webapis) === null || _webapis2 === void 0 ? void 0 : _webapis2.productinfo.getFirmware();
  cachedDevice = toSamsungDevice(model, version);
  return cachedDevice;
};